import {
	QueryClient,
	defaultShouldDehydrateQuery,
	isServer,
} from '@tanstack/react-query';

function makeQueryClient() {
	const TEN_MINUTES = 600000;

	return new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				staleTime:            TEN_MINUTES,
				retry:                (count, error) =>  {
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					if ((error as any).status === 404) return false;

					return count < 3;
				},
			},
			dehydrate: {
				shouldDehydrateQuery: query => defaultShouldDehydrateQuery(query)
					|| query.state.status === 'pending',
			},
		},
	});
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
	if (isServer) {
		return makeQueryClient();
	}
	else {
		if (!browserQueryClient) browserQueryClient = makeQueryClient();

		return browserQueryClient;
	}
}
